export const moduleName = 'advancementReport';
